import { HttpRequestsService } from "../http-requests.service";
import { Injectable } from "@angular/core";
import { LocalStorageService } from "../local-storage.service";
import { jwtDecode } from "jwt-decode";

import { environment } from "src/environments/environment";
import {
  LOCAL_STORAGE_KEYS,
  MERCHANT_ROUTES,
  USER_ROUTES,
} from "src/app/constants/constants";
import { BehaviorSubject, Observable } from "rxjs";
import { FirebaseService } from "../firebase.service";
import { ImpersonationService } from "../impersonation.service";
import { Router } from "@angular/router";
import { MerchantService } from "../merchant/merchant.service";
import { LogoutService } from "../logout.service";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  public currentUserData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // TODO: very ugly naming
  public currentUserSubject: BehaviorSubject<boolean>;
  public currentUser: Observable<any>;
  constructor(
    private localstorage: LocalStorageService,
    private firebaseService: FirebaseService,
    private http: HttpRequestsService,
    private impersonationService: ImpersonationService,
    private readonly router: Router,
    private merchantService: MerchantService,
    private logoutService: LogoutService,
  ) {
    this.currentUserSubject = new BehaviorSubject<boolean>(
      !!this.localstorage.getLocalStore(LOCAL_STORAGE_KEYS.TOKEN),
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.getUserProfile();
    this.currentUserSubject.subscribe((isExist) => {
      if (isExist) {
        this.getUserProfile();
      }
    });
  }

  public isAuthenticated(): boolean {
    return !!this.localstorage.getLocalStore(LOCAL_STORAGE_KEYS.TOKEN);
  }

  public isImpersonated(): boolean {
    const token = this.localstorage.getLocalStore(LOCAL_STORAGE_KEYS.TOKEN);

    // Decode the token
    const decodedToken = jwtDecode(token);

    // Check the azp claim
    const azp = decodedToken["azp"];
    if (azp === "admin-impersonation-client") {
      this.impersonationService.setImpersonated(true);
      return true;
    }
    return false;
  }

  public get currentUserValue() {
    return this.currentUserSubject.asObservable();
  }
  async login(data) {
    const response: any = await this.http.rawPost(
      environment.AUTH_SERVICE,
      USER_ROUTES.SIGN_IN,
      {
        userType: "MERCHANT",
        osType: "Web",
        buildVersion: "1.0.0",
        os: "iOS 9.3.2",
        ipAddress: "",
        ...data,
      },
      true,
    );

    if (response && response.data && response.data != null) {
      this.localstorage.setLocalStore("token", response.data.accessToken);
      this.localstorage.setLocalStore(
        "refreshtoken",
        response.data.refreshToken,
      );
      this.localstorage.setLocalStore(
        "businessname",
        response.data.businessName,
      );
      this.localstorage.setLocalStore("profile", response.data.logo);
      this.localstorage.setLocalStore(
        "userDetails",
        JSON.stringify(response.data),
      );
      this.localstorage.setLocalStore(
        "isSmartieFoods",
        response.data.isSmartieFoods,
      );
      this.localstorage.setDataInIndexedDB(
        LOCAL_STORAGE_KEYS.MOBILECOUNTRYCODE,
        response.data.phoneCountryCode,
      );
      this.localstorage.setDataInIndexedDB(
        LOCAL_STORAGE_KEYS.CURRENCY_SYMBOL,
        response.data.currencySymbol,
      );
      await this.localstorage.setDataInIndexedDB(
        "isSmartieFoods",
        response.data.isSmartieFoods,
      );
      await this.localstorage.setDataInIndexedDB(
        LOCAL_STORAGE_KEYS.ID,
        response.data.id,
      );
      await this.localstorage.setDataInIndexedDB(
        LOCAL_STORAGE_KEYS.FIRSTNAME,
        response.data.firstName,
      );
      await this.localstorage.setDataInIndexedDB(
        LOCAL_STORAGE_KEYS.LASTNAME,
        response.data.lastName,
      );
      if (response.data.userType === "SUBMERCHANT") {
        await this.merchantService.getPrimaryMerchantProfileForStaff(
          response.data.merchantId,
        );
      } else {
        await this.merchantService.setPrimaryMerchantUserId(response.data.id);
      }
      await this.merchantService.isSmartFoodsMerchant();
      this.currentUserSubject.next(true);
      this.firebaseService.requestPermission();
    }
    return response;
  }
  async signUp(data) {
    return await this.http.post(USER_ROUTES.SIGN_UP, data, false);
  }

  async getUserProfile() {
    if (this.isAuthenticated()) {
      const userData: any = await this.http.get(
        USER_ROUTES.PROFILE,
        null,
        false,
      );
      const decoradedUserData = {
        ...userData?.data,
        currencySymbol: await this.localstorage.getDataFromIndexedDB(
          LOCAL_STORAGE_KEYS.CURRENCY_SYMBOL,
        ),
      };
      this.currentUserData.next(decoradedUserData);
      return decoradedUserData;
    }
  }

  async forgotPassword(data) {
    return await this.http.post(USER_ROUTES.FORGOT_PASSWORD, data, true);
  }
  async changePassword(data) {
    return await this.http.post(USER_ROUTES.CHANGE_PASSWORD, data, true);
  }
  async resetPassword(data) {
    return await this.http.post(USER_ROUTES.RESET_PASSWORD, data, false);
  }
  async resetConfirmPassword(data) {
    return await this.http.post(USER_ROUTES.CHANGE_PASSWORD, data, false);
  }
  async verifyOtp(data) {
    return await this.http.post(USER_ROUTES.VERIFY_OTP, data, false);
  }
  async checkOtp(data) {
    return await this.http.post(USER_ROUTES.CHECK_OTP, data, false);
  }
  async emailVerify(data) {
    return await this.http.post(MERCHANT_ROUTES.VERIFY_EMAIL_OTP, data, false, {
      "Accept-Version": "v2",
    });
  }
  async phoneVerify(data) {
    return await this.http.post(MERCHANT_ROUTES.VERIFY_PHONE_OTP, data, false);
  }
  async reSendOtp(data) {
    return await this.http.post(USER_ROUTES.RESEND_OTP, data, false);
  }

  async verifyPasswordLink(uniqueCode) {
    return await this.http.get(
      `${USER_ROUTES.VERIFY_PASSWORD_LINK}${uniqueCode}`,
      false,
    );
  }

  async verifyEmail(uniqueCode) {
    return await this.http.get(
      `${USER_ROUTES.VERIFY_EMAIL}${uniqueCode}`,
      false,
    );
  }
  async updateExplorePin(data) {
    return await this.http.post(MERCHANT_ROUTES.CHANGE_EXPLOREPIN, data, false);
  }
  async savePhone(data) {
    return await this.http.post(MERCHANT_ROUTES.SAVE_PHONE, data, false);
  }
  async updateProfile(data) {
    return await this.http.post(USER_ROUTES.PROFILE, data, true);
  }
  async updateAddress(data) {
    return await this.http.post(USER_ROUTES.ADDERESS_UPDATE, data, true);
  }
  async emailotpforUpdate(data) {
    return await this.http.post(
      MERCHANT_ROUTES.SEND_EMAIL_OTP_UPDATE,
      data,
      false,
    );
  }
  async checkEmail(data) {
    return await this.http.post("user/check-email", data, false);
  }
  async setTransactionPin(data) {
    return await this.http.post(USER_ROUTES.SET_TRANSACTION_PIN, data, true);
  }

  async resendEmailVerifyLink(data) {
    return await this.http.post(USER_ROUTES.RESEND_EMAIL_LINK, data, true);
  }

  async completeKyc(data) {
    return await this.http.post(USER_ROUTES.KYC_SUBMIT, data, true);
  }

  async setWalletData(data) {
    return await this.http.post(USER_ROUTES.SET_WALLET, data, true);
  }

  async setKYCDetails(data) {
    return await this.http.post(USER_ROUTES.KEY_VERIFICATION, data, true);
  }

  async editPassword(data) {
    return await this.http.post(
      MERCHANT_ROUTES.RESET_CONFIRM_PASSWORD,
      data,
      false,
      true,
    );
  }

  setUserData(data: any) {
    this.localstorage.setLocalStore("businessname", data.businessName);
    this.localstorage.setLocalStore(
      "profile",
      data.logo || data.profileImageLarge,
    );
    this.localstorage.setLocalStore("userDetails", JSON.stringify(data));
    this.localstorage.setDataInIndexedDB(
      LOCAL_STORAGE_KEYS.MOBILECOUNTRYCODE,
      data.phoneCountryCode,
    );
    this.localstorage.setDataInIndexedDB(
      LOCAL_STORAGE_KEYS.CURRENCY_SYMBOL,
      data.currencySymbol,
    );
    this.localstorage.setDataInIndexedDB(LOCAL_STORAGE_KEYS.ID, data.id);
    this.localstorage.setDataInIndexedDB(
      LOCAL_STORAGE_KEYS.FIRSTNAME,
      data.firstName,
    );
    this.localstorage.setDataInIndexedDB(
      LOCAL_STORAGE_KEYS.LASTNAME,
      data.lastName,
    );
  }

  async checkImpersonation() {
    // Get token from URL hash (only on initial load)
    const hash = window.location.hash.slice(1); // Remove the # symbol
    const impersonationToken = hash || null;
    if (impersonationToken) {
      try {
        // Clear out any existing user data
        this.localstorage.clearStorage();
        this.localstorage.clearDataFromIndexedDB();

        // Store the real session token
        this.localstorage.setLocalStore("token", impersonationToken);
        this.impersonationService.setImpersonated(true);

        // Fetch the user profile
        const userData: any = await this.http.get(
          USER_ROUTES.PROFILE,
          null,
          false,
        );
        this.setUserData(userData.data);

        // Clean up URL by removing the hash
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
        this.router.navigate(["/home/dashboard"]);

        return true;
      } catch (err) {
        // Invalid or expired impersonation token
        return false;
      }
    }
    return false;
  }

  async logoutUser(msg: string) {
    this.currentUserSubject.next(false);

    await this.logoutService.getLocationWithTimeout();
    await this.logoutService.completeLogout(msg);
  }
}
